import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/$versionId/general")({
  staticData: {
    title: "common.general",
  },
});
